var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "add_notes"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1590_3509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1590_3509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_notes_2",
    d: "M1.58325 14.4666V1.61664H14.4333V9.09997C14.1888 8.92219 13.9333 8.77497 13.6666 8.65831C13.3999 8.54164 13.1277 8.45564 12.8499 8.4003V3.18331H3.14992V12.8833H7.98175C8.00497 13.1722 8.05559 13.4509 8.13359 13.7195C8.2117 13.988 8.31159 14.2371 8.43325 14.4666H1.58325ZM3.14992 12.8833V3.18331V8.39997V8.34997V12.8833ZM4.81659 11.2166H8.11659C8.17214 11.0389 8.23881 10.8694 8.31659 10.7083C8.39436 10.5472 8.49436 10.3833 8.61659 10.2166H4.81659V11.2166ZM4.81659 8.53331H10.5333C10.6444 8.52219 10.7504 8.51275 10.8514 8.50497C10.9525 8.49719 11.0631 8.47331 11.1833 8.43331V7.53331H4.81659V8.53331ZM4.81659 5.84997H11.1833V4.84997H4.81659V5.84997ZM12.0583 15.5833C11.1971 15.5833 10.461 15.2778 9.84992 14.6666C9.23881 14.0555 8.93325 13.3222 8.93325 12.4666C8.93325 11.6063 9.23875 10.8662 9.84975 10.2463C10.4608 9.62653 11.1997 9.31664 12.0666 9.31664C12.9221 9.31664 13.6583 9.62653 14.2749 10.2463C14.8916 10.8662 15.1999 11.6063 15.1999 12.4666C15.1999 13.3222 14.8916 14.0555 14.2749 14.6666C13.6583 15.2778 12.9194 15.5833 12.0583 15.5833ZM11.6333 14.7833H12.5499V12.95H14.3833V12.0166H12.5499V10.1833H11.6333V12.0166H9.79992V12.95H11.6333V14.7833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNotes);
export default __webpack_public_path__ + "static/media/add_notes.56b9e1655daa75f8ff44ee211647cb76.svg";
export { ForwardRef as ReactComponent };